import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<hr class=\"pix-navigation-separator\" />", {
  moduleName: "@1024pix/pix-ui/components/pix-navigation-separator.hbs"
});